<script setup>
</script>

<template>
  <span class="credere-field-tip">
    <font-awesome-icon
      icon="circle-exclamation"
      class="credere-field-tip-icon"
    />

    <span class="credere-field-tip-content">
      <slot />
    </span>
  </span>
</template>

<style lang="scss">
  .credere-field-tip {
    --margin: 0 0 0 var(--token-spacing-mini);

    &:hover::after {
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: calc(var(--token-spacing-micro) * -1);
      bottom: 0;
      width: 100%;
    }

  }

  .credere-field-tip-icon {
    --color: var(--token-color-alert-information);

    cursor: help;
  }

  .credere-field-tip-content {
    --background-color: var(--token-color-alert-information);
    --border-radius: var(--token-border-radius-small);
    --box-shadow: var(--token-box-shadow-around-3);
    --color: var(--token-color-constant-light);
    --padding: var(--token-spacing-xxxs);

    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(100% + var(--token-spacing-micro));

    .credere-field-tip:hover & {
      display: block;
    }
  }
</style>
